module.exports = __webpack_public_path__ + "assets/icon-face-sad-component.97d0cb52.svg";